import { Component, OnInit, OnDestroy } from '@angular/core';
import { ManageService } from '../../../../services/manage.service';
import { CommonService } from '../../../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { CSPPerpetualItemsViewModel, CspAzureRilist, CSPPerpetual_AzureRISubscriptionViewModel, DickerSelectListItem, CspAzureRicatalog, GetProductPricingV2 } from '../../../../models/csp.model';
import { ApiResponse } from '../../../../models/api-response.model';
import { Subject } from 'rxjs';
import { CspAzureLocationModel } from '../../../../models/subscription-details-view.model';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-select-azure-ri',
  templateUrl: './select-azure-ri.component.html',
  styleUrls: ['./select-azure-ri.component.css']
})
export class SelectAzureRiComponent implements OnInit, OnDestroy {

  setFullWindow: boolean = false;
  title: string = "Add Azure Ri Items";
  tenantId: string;
  searchAzureRi: string;
  azureRIItemsPendingList: CSPPerpetualItemsViewModel[] = [];
  azureRiList: CspAzureRilist[];
  azureRiListFilter: CspAzureRilist[];
  azureRiMpnIdSelect: string;
  azureRiUsageSubscriptionList: CSPPerpetual_AzureRISubscriptionViewModel;
  cspItemList: DickerSelectListItem[];
  azureRiCatalog: CspAzureRicatalog[];
  usageSubscriptionId: string;
  priceList: GetProductPricingV2[];
  loadContent: boolean = false;
  usageId: string;
  catalogueId: string;
  mpnList: string[];
  paymentFreqList: any[] = [{"value":'Upfront'}, {"value":'Monthly'}];
  locationList: CspAzureLocationModel[];
  selectedLocation: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  selectedSubscriptionItem: string;

  isMonthlyPayment: boolean = false;
  selectedPaymentFreq: string = 'Upfront';

  constructor(
    private manageService: ManageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.loadContent = false;
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + $('#addazureri').width() + 505 }, 400);
    this.manageService.currentPendingAzureRi.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CSPPerpetualItemsViewModel[]) => {
      this.azureRIItemsPendingList = res;
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
    this.activatedRoute.parent.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      this.tenantId = url[1].path;
      this.activatedRoute.paramMap.subscribe(param => {
        this.catalogueId = param.get('catalogueId');
        this.manageService.GetDefaultMPN().subscribe((res: string[]) => {
          this.mpnList = res;
          if (this.mpnList && this.mpnList.length) {
            this.azureRiMpnIdSelect = this.mpnList[0];
          }
        },
          (error: any) => {
            console.info(error);
            this.loadContent = true;
          });

        this.manageService.GetCSPAzureRIItemList(this.tenantId).subscribe((res: CSPPerpetual_AzureRISubscriptionViewModel) => {
          this.azureRiUsageSubscriptionList = res;
        },
          (error: any) => {
            console.info(error);
            this.loadContent = true;
          });

        this.manageService.GetAzureLocationList().subscribe((res: CspAzureLocationModel[]) => {
          this.locationList = res;
          if (this.locationList.length) {
            this.selectedLocation = this.locationList[0].locationName;
          }
        },
          (error: any) => {
            console.info(error);
            this.loadContent = true;
          });
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
  }

  getCspAzureRiList(): void {
    this.manageService.GetCspAzureRiList(this.commonService.toNumber(this.catalogueId), this.selectedLocation).subscribe((res: CspAzureRilist[]) => {
      this.azureRiList = res;
      this.azureRiList.forEach(item => {
        item.quantity = "1";
        item.minMaxQtyText = "";
        if (item.minQty) {
          item.minMaxQtyText += "Min Order Qty - " + item.minQty + "  ";
        }
        if (item.maxQty) {
          item.minMaxQtyText += "Max Order Qty - " + item.maxQty + "  ";
        }
      });
      let skuList = this.azureRiList.map(x => x.productId + ':' + x.skuId);
      this.manageService.GetProductPricingList(skuList).subscribe((priceList: GetProductPricingV2[]) => {
        if (priceList && priceList.length) {
          this.priceList = priceList;
          this.loadContent = true;
          this.azureRiList.forEach(item => {
            this.priceList.forEach(price => {
              if (price.out_stock_code == item.productId + ":" + item.skuId) {
                item.itemPrice = price.out_current_price;
                item.billingFrequency = price.out_billing_freq;
              }
            });
            if (!item.itemPrice) {
              item.hasPrice = false;
            } else {
              item.hasPrice = true;
            }
          });
        }
        this.azureRiList = this.azureRiList.filter(x => x.hasPrice);
        this.azureRiListFilter = this.azureRiList;

        this.calculateMontlyPayment();

        this.loadContent = true;
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
  }

  filterAzureRiItems(): void {
    this.azureRiListFilter = this.azureRiList.filter(cspAzureRiAddItem => cspAzureRiAddItem.title.toLowerCase().includes(this.searchAzureRi.toLowerCase())
      || cspAzureRiAddItem.productId.toLowerCase().includes(this.searchAzureRi.toLowerCase())
      || cspAzureRiAddItem.skuId.toLowerCase().includes(this.searchAzureRi.toLowerCase())
      || (cspAzureRiAddItem.productId.toLowerCase() + ":" + cspAzureRiAddItem.skuId.toLowerCase()).includes(this.searchAzureRi.toLowerCase()));
  }

  AddAzureRiItem(software: CspAzureRilist): void {
    this.loadContent = false;
    if (this.usageSubscriptionId) {
      this.manageService.GetInventoryCheckForAzureRI(this.tenantId, this.usageSubscriptionId, software.productId, software.skuId, this.locationList.filter(x => x.locationName == this.selectedLocation)[0].armRegionName).subscribe((response: ApiResponse) => {
        if (response && response.status) {
          //if (!this.azureRIItemsPendingList.filter(item => item.productId + item.skuId == software.productId + software.skuId).length) {
            let cSPPerpetualItem = {} as CSPPerpetualItemsViewModel;
            cSPPerpetualItem.maxQty = software.maxQty.toString();
            cSPPerpetualItem.minQty = software.minQty.toString();
            cSPPerpetualItem.productId = software.productId;
            cSPPerpetualItem.description = software.description;
            cSPPerpetualItem.skuId = software.skuId;
            cSPPerpetualItem.title = software.title;
            cSPPerpetualItem.stockCode = software.productId + ":" + software.skuId;
            cSPPerpetualItem.programType = "CSP";
            cSPPerpetualItem.quantity = software.quantity;
            cSPPerpetualItem.itemPrice = software.itemPrice.replace('$', '').replace(',', '');
            cSPPerpetualItem.billingFrequency = software.billingFrequency;
            cSPPerpetualItem.catalogItemId = software.catalogId.toString();
            if (this.isMonthlyPayment) {
              cSPPerpetualItem.totalPrice = this.commonService.toNumber(software.monthlyPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(software.quantity);
            } else {
              cSPPerpetualItem.totalPrice = this.commonService.toNumber(software.itemPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(software.quantity);
            }
            cSPPerpetualItem.mpnId = this.azureRiMpnIdSelect;
            cSPPerpetualItem.lineType = "RESER";
            cSPPerpetualItem.subscriptionId = this.usageSubscriptionId;
            cSPPerpetualItem.isMonthly = this.isMonthlyPayment;
            cSPPerpetualItem.monthlyPrice = software.monthlyPrice;
            this.azureRIItemsPendingList.push(cSPPerpetualItem);
            
          // } else {
          //   this.azureRIItemsPendingList.filter(item => item.productId + item.skuId == software.productId + software.skuId)[0].mpnId = this.azureRiMpnIdSelect;
          //   this.azureRIItemsPendingList.filter(item => item.productId + item.skuId == software.productId + software.skuId)[0].quantity = (toNumber(this.azureRIItemsPendingList.filter(item => item.productId + item.skuId == software.productId + software.skuId)[0].quantity) + toNumber(software.quantity)).toString();
          //   this.azureRIItemsPendingList.filter(item => item.productId + item.skuId == software.productId + software.skuId)[0].totalPrice = toNumber(software.itemPrice.replace('$', '').replace(',', '')) * toNumber(software.quantity);
          // }
          // this.commonService.showSuccess("#" + software.productId + "_" + software.skuId, "New Item added", "right");\
          this.commonService.implementToast("New Item added", "Success");
        } else {
          // this.commonService.showError("#" + software.productId + "_" + software.skuId, "This item is not available", "right");
          this.commonService.implementToast("This item is not available", "Error");
        }
        this.loadContent = true;
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
    } else {
      this.loadContent = true;
      // this.commonService.showError(".usagesub", "Please select a usage subscription", "right");
      this.commonService.implementToast("Please select a usage subscription", "Error");
    }
  }

  finishAddAzureRi(): void {
    if (!this.usageSubscriptionId) {
      // this.commonService.showError(".usagesub", "Please select a usage subscription", "right");
      this.commonService.implementToast("Please select a usage subscription", "Error");
    } else {
      this.manageService.monitorPendingAzureRi(this.azureRIItemsPendingList);
      this.manageService.monitorSelectedTabIndex(3);
      this.manageService.backToTenentPage(this.tenantId);
    }
  }

  selectUsageSubscription(): void {
    this.loadContent = false;
    this.usageSubscriptionId = this.selectedSubscriptionItem;

    if (this.usageSubscriptionId == undefined || this.usageSubscriptionId.length == 0)
      return;

    this.manageService.RegisterSubscription(this.tenantId, this.usageSubscriptionId).subscribe((res: ApiResponse) => {
      this.loadContent = true;
      if (res && !res.status) {
        this.commonService.implementToast(res.responseMessage, "Error");
      } else {
        this.getCspAzureRiList();
      }
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
  }

  selectLocation(): void {

    if (this.usageSubscriptionId == undefined || this.usageSubscriptionId.length == 0)
      return;

    this.loadContent = false;
    this.manageService.GetCspAzureRiList(this.commonService.toNumber(this.catalogueId), this.selectedLocation).subscribe((res: CspAzureRilist[]) => {
      this.azureRiList = res;
      this.azureRiList.forEach(item => {
        item.quantity = "1";
        item.minMaxQtyText = "";
        if (item.minQty) {
          item.minMaxQtyText += "Min Order Qty - " + item.minQty + "  ";
        }
        if (item.maxQty) {
          item.minMaxQtyText += "Max Order Qty - " + item.maxQty + "  ";
        }
      });
      let skuList = this.azureRiList.map(x => x.productId + ':' + x.skuId);
      this.manageService.GetProductPricingList(skuList).subscribe((res: GetProductPricingV2[]) => {
        this.loadContent = true;
        if (res && res.length) {
          this.priceList = res;
          this.loadContent = true;
          this.azureRiList.forEach(item => {
            res.forEach(price => {
              if (price.out_stock_code == item.productId + ":" + item.skuId) {
                item.itemPrice = price.out_current_price;
                item.billingFrequency = price.out_billing_freq;
              }
            });
            if (!item.itemPrice) {
              item.hasPrice = false;
            } else {
              item.hasPrice = true;
            }
          });
        }
        this.azureRiList = this.azureRiList.filter(x => x.hasPrice);
        this.azureRiListFilter = this.azureRiList;
        this.calculateMontlyPayment();
        this.loadContent = true;
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
  }

  showAutoCompletePanel(trigger: any): void {
    trigger.openPanel();
  }

  backToCatalogue(): void {
    this.manageService.monitorPendingAzureRi(this.azureRIItemsPendingList);
    // $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 500 }, 400);
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
  }

  // toggleActive(event: any): void {

  //   this.isMonthlyPayment = event.checked;
  // }

  selectPaymentFrequency(): void {
    this.isMonthlyPayment = this.selectedPaymentFreq === 'Monthly';
  }

  calculateMontlyPayment(): void {

    this.azureRiListFilter.map(item => {
      if (item.title.includes('1 Year')) {
        item.monthlyPrice = (parseFloat(item.itemPrice) / 12).toFixed(2);
      } else if (item.title.includes('3 Years')) {
        item.monthlyPrice = (parseFloat(item.itemPrice) / 36).toFixed(2);
      }
    });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    if (this.azureRIItemsPendingList.length) {
      this.manageService.monitorPendingAzureRi(this.azureRIItemsPendingList);
      this.manageService.monitorSelectedTabIndex(3);
      this.manageService.backToTenentPage(this.tenantId);
    } else {
      this.backToCatalogue();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
